var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6501 44.65C11.1925 44.65 9.94481 44.1311 8.90688 43.0932C7.86894 42.0552 7.34998 40.8075 7.34998 39.35V8.65007C7.34998 7.19254 7.86894 5.94481 8.90688 4.90688C9.94481 3.86894 11.1925 3.34998 12.6501 3.34998H35.35C36.8075 3.34998 38.0552 3.86894 39.0932 4.90688C40.1311 5.94481 40.6501 7.19254 40.6501 8.65007V39.35C40.6501 40.8075 40.1311 42.0552 39.0932 43.0932C38.0552 44.1311 36.8075 44.65 35.35 44.65H12.6501ZM29.9128 27.3674C30.868 27.3674 31.6797 27.0345 32.3478 26.3688C33.0159 25.703 33.35 24.8946 33.35 23.9435C33.35 22.9846 33.0206 22.1694 32.3619 21.4982C31.7032 20.8269 30.8935 20.4913 29.9327 20.4913C28.9719 20.4913 28.1552 20.8276 27.4827 21.5001C26.8101 22.1727 26.4739 22.9894 26.4739 23.9502C26.4739 24.9109 26.8082 25.7207 27.4769 26.3794C28.1455 27.0381 28.9575 27.3674 29.9128 27.3674Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorDoor);
export default __webpack_public_path__ + "static/media/sensorDoor.43fd67963144fbfd63e527a814ad43d6.svg";
export { ForwardRef as ReactComponent };